import { useEffect } from 'react';
import { onMessageListener, requestForToken } from '../services/firebase';
import { updateFCMToken } from '../services/api';
import { toast } from 'react-toastify';

const NotificationHandler = ({ userId }) => {
  console.log("User Id : " , userId)
  useEffect(() => {
    if (!userId) return;

    const setupNotifications = async () => {
      try {
        // Request token and save to backend
        const token = await requestForToken();
        if (token) {
          await updateFCMToken(userId, token);
        }

        // Listen for incoming messages
        const payload = await onMessageListener();
        if (payload) {
          toast.info(payload.notification.body, {
            position: "top-right",
            autoClose: 5000,
          });
          
          // You can also handle the notification data
          console.log('Notification received:', payload);
        }
      } catch (error) {
        console.error('Notification setup error:', error);
      }
    };

    setupNotifications();
  }, [userId]);

  return null; // This is a non-rendering component
};

export default NotificationHandler;